var oldURL = document.referrer;

function varBack(oldURL){
  var submit_id_hidden = document.getElementById("rtvdv");
  //var attrib = submit_id_hidden["attributes"][3];
  submit_id_hidden.setAttribute("value", oldURL); 
  console.log(oldURL);
}

document.addEventListener("DOMContentLoaded", function() {
  varBack(oldURL);
});